let mistakesState={
    mistakes: [],
    mistakesFiltered: [],
    mistakesCut: [],
    currentSubjectIdMistakes: '',
    currentSubjectNameMistakes: ''
}

export default mistakesState;